import React, { useState, useEffect } from 'react'
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import { useTranslation } from "react-i18next";
import backButton from "../../assets/images/back_button.svg";
import { useStyles } from '../../assets/jss/EventDetails';
import CustomButton from "../../components/CustomComponents/CustomButton/CustomButton";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import MotorwayIcon from '../../assets/images/motorway.svg'
import DrivingBanIcon from "../../assets/images/drivingBan.svg";
import SchoolIcon from "../../assets/images/school.svg";
import WarningSeverityIcon from "../../assets/images/warningSeverity.svg";
import AlertSeverityIcon from "../../assets/images/alertSeverity.svg";
import SevereSeverityIcon from "../../assets/images/severSeverity.svg";
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import { getEventDetail, reportEvent } from '../../services/PraisoTableService';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { convertLatInDecimal } from '../../config/app-global-method';
import ReportEventActionDialog from '../../components/Dialogs/ConfirmAction/ReportEventAction';
import ErrorAlert from '../../components/ErrorAlert/ErrorAlert';
import { CALL_EVENT, CALL_EVENT_DESC_ENUM, EventTypes, PHONE_USAGE_EVENT, PHONE_USAGE_EVENT_DESC_ENUM, ReportedEventStatus, ReportEventEnum } from '../../config/app-globals.enum';
import { dateTimeConvert, flat, kMPToMPH } from '../../assets/helperFunctions';
import CustomCircularProgress from '../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress';
import CustomPaper from '../../components/CustomComponents/CustomPaper/CustomPaper';
import { useHistory } from "react-router-dom";
import CustomLink from '../../components/CustomComponents/CustomLink/CustomLink';
import { getEventCategoryFromEventType, setIsCameFromEventDetailsPage } from "../../services/LocalStorageService";
import GoogleMapIcon from "../../assets/images/googleMapIcon.png";

const ReportedEventDetails = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const params = useParams();
    const history = useHistory();
    const [eventCategory, setEventCategory] = useState(null);
    const [eventDetail, setEventDetail] = useState<any>({});
    const [eventSeverity, setEventSeverity] = useState<any>({});
    const [eventData, setEventData] = useState<any>([]);
    const [isApi, setIsApi] = useState(true);
    // const [reportEventPeriod] = React.useState(getReportEventPeriod);
    const [startLat, setStartLat] = useState(null);
    const [startLng, setStartLng] = useState(null);
    const [endLat, setEndLat] = useState(null);
    const [endLng, setEndLng] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const getDataValue = [
        { name: "startLat", cat: "degreeLat", show: "START_FORMATTED_LATITUDE", value: "" },
        { name: "startLng", cat: "degreeLng", show: "START_FORMATTED_LONGITUDE" },
        { name: "endLat", cat: "degreeLat", show: "END_FORMATTED_LATITUDE" },
        { name: "endLng", cat: "degreeLng", show: "END_FORMATTED_LONGITUDE" },
        { name: "startSpeed", cat: "speed", show: "START_SPEED" },
        { name: "endSpeed", cat: "speed", show: "END_SPEED" },
        { name: "milliG", cat: "view", show: "MILLIG" },
        { name: "roadSpeedLimit", cat: "speed", show: "ROADSPEEDLIMIT_SPEED", isMoreInfo: true },
        { name: "maxSpeed", cat: "speed", show: "MAX_SPEED", isMoreInfo: true },
        { name: "minSpeed", cat: "speed", show: "MIN_SPEED", isMoreInfo: true },
        { name: "avgSpeed", cat: "speed", show: "AVG_SPEED", isMoreInfo: true },
        { name: "userId", cat: "view", show: "DRIVER_ID", isMoreInfo: true },
        { name: "name", cat: "view", show: "DRIVER_NAME", isMoreInfo: true },
        { name: "providerId", cat: "view", show: "DRIVER_PROVIDERID", isMoreInfo: true },
        { name: "penaltyPoint", cat: "view", show: "PENALTY_POINT", isMoreInfo: true },
        { name: "startTime", cat: "date", show: "EVENT_STARTTIME", isMoreInfo: true },
        { name: "endTime", cat: "date", show: "EVENT_ENDTIME", isMoreInfo: true },
        { name: "rejectedReason", cat: "view", show: "REJECT_REASON", isMoreInfo: true },
        { name: "isBannedEvent", cat: "view", show: "IS_BANNED_EVENT", isMoreInfo: true }
    ];

    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [rejectedReason, setRejectedReason] = useState(null);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    async function loadData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsApi(true);
        const data = await getEventDetail(params);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            const eventData = data.content;
            setEventCategory(getEventCategoryFromEventType(eventData.eventDetails.eventTypeId));
            let eventDtls = flat(eventData, {});
            let eventSeverityDtls = eventData.eventSeverityDtls;
            eventSeverityDtls.name = eventData.name;
            eventSeverityDtls.severity = eventDtls.severity;
            const result = getDataValue.map((ev) => {
                if (ev.cat === "degreeLat") {
                    if (eventDtls[ev.name]) {
                        ev.value = convertLatInDecimal(eventDtls[ev.name]);
                        if (ev.name === "startLat") {
                            setStartLat(ev.value);
                        }
                        if (ev.name === "endLat") {
                            setEndLat(ev.value);
                        }
                    } else {
                        if (eventData?.eventDetails?.startLocation?.latitude) {
                            ev.value = convertLatInDecimal(eventData.eventDetails.startLocation.latitude + "");
                            if (ev.value) {
                                setStartLat(ev.value);
                            }
                        }
                        if (eventData?.eventDetails?.endLocation?.latitude) {
                            ev.value = convertLatInDecimal(eventData.eventDetails.endLocation.latitude + "");
                            if (ev.value) {
                                setEndLat(ev.value);
                            }
                        }
                    }

                } else if (ev.cat === "degreeLng") {
                    if (eventDtls[ev.name]) {
                        ev.value = convertLatInDecimal(eventDtls[ev.name]);
                        if (ev.name === "startLng") {
                            setStartLng(ev.value);
                        }
                        if (ev.name === "endLng") {
                            setEndLng(ev.value);
                        }
                    } else {
                        if (eventData?.eventDetails?.startLocation?.longitude) {
                            ev.value = convertLatInDecimal(eventData.eventDetails.startLocation.longitude + "");
                            if (ev.value) {
                                setStartLng(ev.value);
                            }
                        }
                        if (eventData?.eventDetails?.endLocation?.longitude) {
                            ev.value = convertLatInDecimal(eventData.eventDetails.endLocation.longitude + "");
                            if (ev.value) {
                                setEndLng(ev.value);
                            }
                        }
                    }
                } else if (ev.cat === "speed") {
                    if (eventDtls[ev.name]) {
                        ev.value = kMPToMPH(eventDtls[ev.name]);
                    } else {
                        if (eventData?.eventDetails?.startLocation?.speed) {
                            if (ev.name === "startSpeed")
                                ev.value = kMPToMPH(eventData.eventDetails.startLocation.speed);
                        }
                        if (eventData?.eventDetails?.endLocation?.speed) {
                            if (ev.name === "endSpeed")
                                ev.value = kMPToMPH(eventData.eventDetails.endLocation.speed)
                        }
                    }

                } else if (ev.cat === "date") {
                    if (eventDtls[ev.name]) {
                        ev.value = dateTimeConvert(eventDtls[ev.name]);
                        if (ev.value) {
                            if (ev.name === "startTime") {
                                setStartTime(ev.value);
                            }
                            if (ev.name === "endTime") {
                                setEndTime(ev.value);
                            }
                        }
                    } else {
                        if (eventData?.eventDetails?.startLocation?.logTime) {
                            setStartTime(dateTimeConvert(eventData.eventDetails.startLocation.logTime));
                        }
                        if (eventData?.eventDetails?.endLocation?.logTime) {
                            setEndTime(dateTimeConvert(eventData.eventDetails.endLocation.logTime));
                        }
                    }
                } else {
                    ev.value = eventDtls[ev.name];
                }
                return ev;
            });
            setEventSeverity(eventSeverityDtls);
            setEventDetail(result);
            if (result) {
                const rejReason = result.filter((item) => item?.name === 'rejectedReason')
                if (rejReason && rejReason.length > 0) {
                    setRejectedReason(rejReason[0].value)
                } else {
                    setRejectedReason(null)
                }
            }
            if (eventData?.eventDetails?.subEventTypeId)
                eventDtls.subEventTypeId = eventData.eventDetails.subEventTypeId;
            setEventData(eventDtls);
            setIsApi(false);
        } else {
            if (data && data.status) {
                changeApiStatusCodeFunc(data.status);
            }
        }
    }

    useEffect(() => {
        loadData();
    }, [eventCategory]);

    const [eventStatusValue, setEventStatusValue] = React.useState(null);
    const [eventAlertType, setEventAlertType] = React.useState(null);
    const [eventAlertMessage, setEventAlertMessage] = React.useState("");
    const [eventAlertDescription, setEventAlertDescription] = React.useState("");
    const [isEventAlertOpen, setIsEventAlertOpen] = React.useState(false);
    const changeEventApiStatusCodeFunc = (status, action?: any) => {
        setEventStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setEventAlertMessage(status.message ? status.message : t("SUCCESS"));
            setEventAlertType("success");
            setEventAlertDescription(t("EVENT_HAS_BEEN_REPORTED_SUCCESSFULLY"));
        } else {
            setEventAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setEventAlertType("error");
            setEventAlertDescription(t("FAILED_TO_REPORT_EVENT"));
        }
        setIsEventAlertOpen(true);
    };

    async function reportEventFun(value) {
        const request = {
            eventId: eventSeverity.eventId,
            userId: eventData.userId,
            occurredAt: eventSeverity.occurredAt,
            reason: value
        }
        const data = await reportEvent(request);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setOpen(false);
            changeEventApiStatusCodeFunc(data.status);
            setTimeout(() => {
                history.replace(`/eventdetails/${eventData.userId}/${eventData.eventId}/${ReportedEventStatus.REPORTED}`);
            }, 200);
            setTimeout(() => {
                window.localStorage.removeItem("API");
            }, 200);
        } else {
            setOpen(false);
            changeEventApiStatusCodeFunc(data.status);
        }
    }

    const [open, setOpen] = useState(false);
    const handleClose = (isOpen, confirmDelete, value) => {
        if (confirmDelete) {
            reportEventFun(value);
        } else {
            setOpen(isOpen);
        }
    };

    const getSeverityIcon = (eventSeverity: number) => {
        if (eventSeverity === 1) {
            return <img src={WarningSeverityIcon} alt="Warning" />
        } else if (eventSeverity === 2) {
            return <img src={AlertSeverityIcon} alt="Alert" />
        } else if (eventSeverity === 3) {
            return <img src={SevereSeverityIcon} alt="Severe" />
        }
        return null;
    }

    const [viewMore, setViewmore] = useState(false);
    const handleViewMore = () => {
        setViewmore(!viewMore);
    }

    const goBackFunc = () => {
        setIsCameFromEventDetailsPage(1);
        history.goBack();
    }

    useEffect(() => {
        return () => {
            if (history.action === "POP") {
                setIsCameFromEventDetailsPage(1);
            }
        };
    }, [history])

    const isTimePeriodOver = (param) => {
        return false;
    };

    const getEventDuration = (duration) => {
        let timeDuration = "";
        if (duration && duration > 0 && Number((duration / (60 * 60)).toFixed(2)) >= 1) {
            timeDuration = (duration / (60 * 60)).toFixed(2) + " " + t('HOURS');
        } else if (duration && duration > 0 && Number((duration / (60)).toFixed(2)) > 1 && Number((duration / (60)).toFixed(2)) < 60) {
            timeDuration = (duration / 60).toFixed(2) + " " + t('MINUTES');
        } else if (duration && duration > 0) {
            timeDuration = duration + " " + t('SECONDS');
        } else {
            timeDuration = "-"
        }
        return timeDuration;
    }

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <Breadcrumb
                        currentPage={t("EVENT_DETAILS")}
                    />
                </CustomGrid>
            </CustomGrid>
            <CustomGrid container spacing={0} justifyContent="space-between" alignItems='center'>
                <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.headerTitle}
                >
                    <img
                        src={backButton}
                        onClick={goBackFunc}
                        style={{ marginRight: "20px", cursor: "pointer" }}
                        alt="Back"
                    />
                    {t("EVENT_DETAILS")}
                </CustomTypography>
                {eventData.reportStatus === ReportedEventStatus.NO_REPORT && !isTimePeriodOver(eventSeverity.occurredAt) && !isApi ? <CustomButton className={classes.reportEventBtn} onClick={() => setOpen(true)} >
                    {t('REPORT_EVENT')}
                </CustomButton> : null}
            </CustomGrid>

            {isApi ? <CustomPaper
                className={classes.loadingContainer}
                elevation={0}
            >
                <CustomCircularProgress />
            </CustomPaper> : <>
                <CustomBox className={classes.info} key={2}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableRowHeading}>
                                <th className={classes.eventHeading}>{t("DRIVER_INVOLVED")}</th>
                                {eventCategory == EventTypes.SPEEDING ? (
                                    <>
                                        <th>{t("SPEED")}</th>
                                        <th>{t("SPEED_LIMIT")}</th>
                                        <th>{t("SEVERITY")}</th>
                                        <th>{t("SCHOOL_RUN_SPEEDING")}</th>
                                        <th>{t("MOTORWAY_SPEEDING")}</th>
                                        <th>{t("DRIVING_BAN")}</th>
                                    </>

                                ) : eventCategory == EventTypes.DISTRACTION ? (
                                    <>
                                        <th>{t("DURATION")}</th>
                                        <th>{t("SEVERITY")}</th>
                                        <th>{t("EVENT")}</th>
                                        <th>{t("SUB_EVENT")}</th>
                                    </>
                                ) : (
                                    <>
                                        <th>{t("SEVERITY")}</th>
                                        <th>{t("EVENT")}</th>
                                    </>
                                )
                                }

                            </tr>
                        </thead>
                        <tbody>
                            <tr className={classes.tableRowData}>
                                <td className={classes.eventRowData}> <CustomTypography className={classes.driverName}>{eventSeverity.name}</CustomTypography> <p className={classes.subtitleLabel}>{eventSeverity.occurredAt ? moment(eventSeverity.occurredAt).format("dddd, DD, MMM, YYYY | hh:mm:ss A") : "-"}</p></td>
                                {eventCategory == EventTypes.SPEEDING ? (
                                    <>
                                        <td>{eventSeverity.speed}</td>
                                        <td>{eventSeverity.speedLimit}</td>
                                        <td>{getSeverityIcon(eventSeverity.severity)}</td>
                                        <td>{eventSeverity.isSchoolRunSpeeding ? <img src={SchoolIcon} alt="SchoolIcon" /> : null}</td>
                                        <td>{eventSeverity.isMotorwaySpeeding ? <img src={MotorwayIcon} alt="MotorwayIcon" /> : null}</td>
                                        <td>{eventSeverity.isDriverBan ? <img src={DrivingBanIcon} alt="DrivingBanIcon" /> : null}</td>
                                    </>
                                ) : eventCategory == EventTypes.DISTRACTION ? (
                                    <>
                                        <td>{getEventDuration(eventData.eventDuration)}</td>
                                        <td>{getSeverityIcon(eventSeverity.severity)}</td>
                                        <td>{+eventSeverity.eventTypeId === EventTypes.CALL_EVENT ? t("CALL_EVENT") : t("PHONE_USAGE_EVENT")}</td>
                                        <td>{+eventSeverity.eventTypeId === EventTypes.CALL_EVENT ?
                                            (+eventData.subEventTypeId === CALL_EVENT.ANSWER_CALL ? t(CALL_EVENT_DESC_ENUM.ANSWER_CALL) :
                                                +eventData.subEventTypeId === CALL_EVENT.END_CALL ? t(CALL_EVENT_DESC_ENUM.END_CALL) :
                                                    +eventData.subEventTypeId === CALL_EVENT.OUTGOING_CALL ? t(CALL_EVENT_DESC_ENUM.OUTGOING_CALL) :
                                                        +eventData.subEventTypeId === CALL_EVENT.REJECT_CALL ? t(CALL_EVENT_DESC_ENUM.REJECT_CALL) : null) :
                                            (+eventData.subEventTypeId === PHONE_USAGE_EVENT.CHARGER_PLUG_IN ? t(PHONE_USAGE_EVENT_DESC_ENUM.CHARGER_PLUG_IN) :
                                                +eventData.subEventTypeId === PHONE_USAGE_EVENT.CHARGER_PLUG_OUT ? t(PHONE_USAGE_EVENT_DESC_ENUM.CHARGER_PLUG_OUT) :
                                                    +eventData.subEventTypeId === PHONE_USAGE_EVENT.DEVICE_LOCK ? t(PHONE_USAGE_EVENT_DESC_ENUM.DEVICE_LOCK) :
                                                        +eventData.subEventTypeId === PHONE_USAGE_EVENT.DEVICE_UNLOCK ? t(PHONE_USAGE_EVENT_DESC_ENUM.DEVICE_UNLOCK) :
                                                            +eventData.subEventTypeId === PHONE_USAGE_EVENT.SCREEN_DISPLAY_ON ? t(PHONE_USAGE_EVENT_DESC_ENUM.SCREEN_DISPLAY_ON) :
                                                                +eventData.subEventTypeId === PHONE_USAGE_EVENT.SCREEN_DISPLAY_OFF ? t(PHONE_USAGE_EVENT_DESC_ENUM.SCREEN_DISPLAY_OFF) :
                                                                    null)

                                        }</td>
                                    </>
                                ) : (
                                    <>
                                        <td>{getSeverityIcon(eventSeverity.severity)}</td>
                                        <td>
                                            {
                                                +eventSeverity.eventTypeId === EventTypes.HARSH_BRAKING ? t("HARSH_BRAKING") :
                                                    +eventSeverity.eventTypeId === EventTypes.BRAKE_OVERUSE ? t("BRAKE_OVERUSE") :
                                                        +eventSeverity.eventTypeId === EventTypes.TAILGATING ? t("TAILGATING") :
                                                            +eventSeverity.eventTypeId === EventTypes.EXCESS_SPEED ? t("EXCESS_SPEED") :
                                                                +eventSeverity.eventTypeId === EventTypes.POOR_TECHNIQUE ? t("POOR_TECHNIQUE") :
                                                                    +eventSeverity.eventTypeId === EventTypes.FAST_APPROACH ? t("FAST_APPROACH") :
                                                                        +eventSeverity.eventTypeId === EventTypes.HARSH_ACCELERATION ? t("HARSH_ACCELERATION") :
                                                                            null
                                            }
                                        </td>
                                    </>
                                )}

                            </tr>
                        </tbody>
                    </table>
                </CustomBox>

                <CustomBox className={classes.containerMore}>
                    <CustomTypography className={classes.journeyDetails}>{t('JOURNEY_EVENT_DETAILS')}</CustomTypography>
                    <CustomGrid container spacing={1} >
                        <CustomGrid item lg={4} md={6} sm={12} xs={3} className={classes.displayEventData}>
                            <CustomTypography className={classes.journeyDetailsTitle}>{startLat && startLng ? (
                                <>
                                    {`${startLat} | ${startLng}`}
                                    <a href={`http://maps.google.com/?q=${startLat},${startLng}`} target="_blank" rel="noopener noreferrer">
                                        <img src={GoogleMapIcon} className={classes.mapIcon} />
                                    </a>
                                </>
                            ) : "-"}</CustomTypography>
                            <CustomTypography className={classes.journyDate}>{startTime ? startTime : "N/A"}</CustomTypography>
                            <CustomTypography className={classes.journeyDetailsSubTitle}>{t("START_LATITUDE_AND_LONGITUDE")}</CustomTypography>
                        </CustomGrid>
                        <CustomGrid item lg={4} md={6} sm={12} xs={3} className={classes.displayEventData}>
                            <CustomTypography className={classes.journeyDetailsTitle}>{endLat && endLng ? (
                                <>
                                    {`${endLat} | ${endLng}`}
                                    <a href={`http://maps.google.com/?q=${endLat},${endLng}`} target="_blank" rel="noopener noreferrer">
                                        <img src={GoogleMapIcon} className={classes.mapIcon} />
                                    </a>
                                </>
                            ) : "-"}</CustomTypography>
                            <CustomTypography className={classes.journyDate}>{endTime ? endTime : "N/A"}</CustomTypography>
                            <CustomTypography className={classes.journeyDetailsSubTitle}>{t("END_LATITUDE_AND_LONGITUDE")}</CustomTypography>
                        </CustomGrid>
                    </CustomGrid>


                    <CustomGrid container spacing={1} >
                        {eventDetail.map((ev, i) => {
                            if (ev.cat !== "degreeLat" && ev.cat !== "degreeLng" && ev.cat !== "date") {
                                if (ev.isMoreInfo === undefined || ev.isMoreInfo === viewMore) {
                                    return (
                                        <CustomGrid key={i} item lg={4} md={6} sm={12} xs={12} className={classes.displayEventData}>
                                            <CustomTypography className={classes.journeyDetailsTitle}>{ev.value ? ev.value : "-"}</CustomTypography>
                                            <CustomTypography className={classes.journeyDetailsSubTitle}>{t(ev.show)}</CustomTypography>
                                        </CustomGrid>
                                    );
                                }
                            }
                        })}
                    </CustomGrid>
                    {<CustomBox style={{ textAlign: 'center', backgroundColor: '#ffffff', height: '50px', cursor: 'pointer' }}>
                        <CustomLink onClick={handleViewMore} style={{ color: '#1783ff' }}>{viewMore ? "View less" : "View More"}</CustomLink>
                    </CustomBox>}
                </CustomBox>
                {eventData.reason && eventData.reason.length > 0 && <CustomBox container className={classes.messageBox}>
                    <p className={classes.mesgHeading}>
                        {t('REASON_FOR_REQUEST')}
                    </p>
                    <p className={classes.subtitleLabel}>
                        {eventData.reason}
                    </p>
                </CustomBox>}

                {rejectedReason && <CustomBox container className={classes.messageBox}>
                    <p className={classes.mesgHeading}>
                        {t('REASON_FOR_REJECT')}
                    </p>
                    <p className={classes.subtitleLabel}>
                        {rejectedReason}
                    </p>
                </CustomBox>}
            </>}
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                alertType={"error"}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={eventStatusValue}
                message={eventAlertMessage}
                description={eventAlertDescription}
                isOpen={isEventAlertOpen}
                alertType={eventAlertType}
                isClose={(isClose) => setIsEventAlertOpen(!isClose)}
            />
            <ReportEventActionDialog
                dialogOpen={open}
                dialogClose={(isOpen, confirmDelete, value) =>
                    handleClose(isOpen, confirmDelete, value)
                }
            />

        </>
    )
}

export default ReportedEventDetails